import { createFileRoute } from '@tanstack/react-router'
import { DashboardLayout } from '@/app/layouts/dashboard-layout'
import { getLocalizedText } from '@/shared/utils/locale'
import { DashboardWidget, useDashboardControls } from '@/widgets/dashboard-widget'

export const Route = createFileRoute('/_dashboard/dashboard')({
  component: RouteComponent,
})

function RouteComponent() {
  const controls = useDashboardControls()

  const selectedSchoolOption = controls.schoolOptions.find(
    (option) => option.value === controls.selectedSchoolId
  )

  const schoolName =
    selectedSchoolOption?.title ??
    getLocalizedText(controls.currentUser?.company?.nameRu, controls.currentUser?.company?.nameKk)

  const canteenName = getLocalizedText(
    controls.currentUser?.company?.nameRu,
    controls.currentUser?.company?.nameKk
  )

  return (
    <DashboardLayout schoolName={schoolName} canteenName={canteenName}>
      <DashboardWidget controls={controls} />
    </DashboardLayout>
  )
}
